class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);
  }

  async handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    try {
      const autoLimit = 9;
      const manualLimit = 3;

      const cartHandles = (this.dataset.cartHandles || '')
        .split('|')
        .filter(Boolean);

      const currentManualItems = Array.from(
        this.querySelectorAll('.mini-cart__rec-item.is-manual')
      );

      const primaryItems = await this.fetchRecommendationItems(this.dataset.url);
      const secondaryItems = this.dataset.urlSecondary
        ? await this.fetchRecommendationItems(this.dataset.urlSecondary)
        : [];

      const usedAutoHandles = new Set(cartHandles);
      const autoItems = [];

      [...primaryItems, ...secondaryItems].forEach((item) => {
        const handle = item.dataset.recHandle || '';

        if (!handle || usedAutoHandles.has(handle)) return;

        usedAutoHandles.add(handle);
        item.classList.add('is-auto');

        if (autoItems.length < autoLimit) {
          autoItems.push(item);
        }
      });

      const manualItems = [];

      currentManualItems.forEach((item) => {
        const handle = item.dataset.recHandle || '';

        if (!handle || cartHandles.includes(handle)) return;

        item.classList.add('is-manual');

        if (manualItems.length < manualLimit) {
          manualItems.push(item);
        }
      });

      const finalItems = [...autoItems, ...manualItems];
      const list = this.querySelector('.mini-cart__navigation');

      if (list && finalItems.length) {
        list.innerHTML = '';
        finalItems.forEach((item) => list.appendChild(item));
        this.buildDots(list);
      }

      const miniCartMain = document.querySelector('#main-cart-items');
      if (miniCartMain) {
        miniCartMain.scrollTop -= miniCartMain.scrollHeight;
      }
    } catch (e) {
      console.error(e);
    }
  }

  async fetchRecommendationItems(url) {
    if (!url) return [];

    const response = await fetch(url);
    const text = await response.text();

    const html = document.createElement('div');
    html.innerHTML = text;

    const recommendations = html.querySelector('cart-recommendations');

    if (!recommendations) return [];

    return Array.from(
      recommendations.querySelectorAll('.mini-cart__rec-item.is-auto, .mini-cart__navigation > li')
    );
  }

  buildDots(list) {
    const items = Array.from(list.children);
    let dots = this.querySelector('.mini-cart__dots');

    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'mini-cart__dots';
      list.after(dots);
    }

    dots.innerHTML = '';

    if (items.length <= 1) {
      dots.hidden = true;
      return;
    }

    dots.hidden = false;

    items.forEach((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `mini-cart__dot${index === 0 ? ' is-active' : ''}`;
      button.setAttribute('aria-label', `Produktas ${index + 1}`);

      button.addEventListener('click', () => {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        this.setActiveDot(dots, index);
      });

      dots.appendChild(button);
    });

    list.addEventListener('scroll', () => {
      const listRect = list.getBoundingClientRect();
      const listCenter = listRect.left + listRect.width / 2;

      let activeIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distance = Math.abs(listCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.setActiveDot(dots, activeIndex);
    }, { passive: true });
  }

  setActiveDot(dots, activeIndex) {
    Array.from(dots.children).forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);